import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { render } from 'react-dom';
import dataModel from './models/DataModel';
import CacheUtil from './helpers/session/CacheUtil';
import App from './App';
import './index.scss';
import I18N from './containers/I18N';

CacheUtil.reloadSpaIfNeeded();

render(
  <Provider store={dataModel.store}>
    <PersistGate persistor={dataModel.persistor}> 
      <I18N>
        <App/>
      </I18N>
    </PersistGate>
  </Provider>,
document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js